import React from 'react'

interface QrCodeBoxProps {
  size?: number
  color?: string
}

export const QrCodeBox: React.FC<QrCodeBoxProps> = ({
  size = 24,
  color = '#000',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer squares */}
      <rect
        x="3"
        y="3"
        width="7"
        height="7"
        stroke={color}
        strokeWidth="2"
        fill="none"
      />
      <rect
        x="14"
        y="3"
        width="7"
        height="7"
        stroke={color}
        strokeWidth="2"
        fill="none"
      />
      <rect
        x="3"
        y="14"
        width="7"
        height="7"
        stroke={color}
        strokeWidth="2"
        fill="none"
      />

      {/* Inner squares */}
      <rect x="5" y="5" width="3" height="3" fill={color} />
      <rect x="16" y="5" width="3" height="3" fill={color} />
      <rect x="5" y="16" width="3" height="3" fill={color} />

      {/* QR pattern elements */}
      <rect x="14" y="14" width="2" height="2" fill={color} />
      <rect x="17" y="14" width="2" height="2" fill={color} />
      <rect x="14" y="17" width="2" height="2" fill={color} />
      <rect x="19" y="17" width="2" height="2" fill={color} />
      <rect x="17" y="19" width="2" height="2" fill={color} />
      <rect x="14" y="21" width="2" height="2" fill={color} />
      <rect x="19" y="21" width="2" height="2" fill={color} />
    </svg>
  )
}
